import { render, staticRenderFns } from "./OrderTag.vue?vue&type=template&id=045c697c&lang=pug"
import script from "./OrderTag.vue?vue&type=script&lang=js"
export * from "./OrderTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports